import '../../sass/plugins/our_team_secondary.scss';
import { MEDIUM_SCREEN, EXTRA_LARGE_SCREEN } from '../consts';

const XXL_SCREEN = EXTRA_LARGE_SCREEN + 200;

$(() => {
  const leadersCount = $('.our-team-2-carousel-element').length;
  const sliderTop = $('#our-team-2-carousel');
  const sliderBottom = $('#our-team-2-carousel-details');
  const nextArrow = $('#our-team-2-carousel-next-arrow');
  const prevArrow = $('#our-team-2-carousel-prev-arrow');

  sliderTop.slick({
    infinite: true,
    variableWidth: true,
    centerMode: true,
    mobileFirst: true,
    slidesToShow: 3,
    swipe: true,
    nextArrow,
    prevArrow,
    asNavFor: '#our-team-2-carousel-details',
    responsive: [
      {
        breakpoint: MEDIUM_SCREEN,
        settings: {
          variableWidth: false,
          slidesToShow: leadersCount > 3 ? 3 : leadersCount,
          centerPadding: '30px',
        },
      },
      {
        breakpoint: XXL_SCREEN,
        settings: {
          variableWidth: false,
          slidesToShow: leadersCount > 5 ? 5 : leadersCount,
          centerPadding: '20px',
        },
      },
    ],
  });

  sliderBottom.slick({
    infinite: true,
    arrows: false,
    fade: true,
    swipe: true,
    mobileFirst: true,
    asNavFor: '#our-team-2-carousel',
  });
});
